<template>

    <section :id="component.identifier ? component.identifier : ''" class="mb-64" v-if="show">

        <component-header :title="title" :description="description"></component-header>

        <div class="site__container">

            <div class="flex flex-wrap justify-center my-64 -mx-16" ref="container">
                <div v-for="(perk, index) in translatedPerks" :key="perk.id"
                     class="mb-24 text-center perk-container"
                     :class="[perksIconsWidth]">
                        <div :class="[perks2Margins]">

                            <div v-if="perk.image_url != ''" class="pt-60pct relative">

                                <div class="absolute inset-0 w-full h-full flex items-center justify-center site__rounded--small">
                                    <img :src="perk.image_url +'&w=550&fit=max'" class="block w-full h-full max-w-full max-h-full opacity-0">
                                </div>

                            </div>

                            <h2 class="font-semibold break-words site__font--display text-heading-2 pb-16 pt-24">{{ translated(perk.title) }}</h2>
                            <p class="text-body">{{ translated(perk.value) }}</p>
                        </div>
                </div>
            </div>

        </div>
    </section>

</template>

<script>
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import { useBrandingStore } from '../../state/branding'
import ComponentHeader from './ComponentHeader.vue';
import { responsive, runningInBrowser, containRetinaImages } from '../../helpers';

export default {
    components: {
        'component-header': ComponentHeader,
    },
    props: {
        component: {
            required: true,
        }
    },
    data: function () {
        return {}
    },
    computed: {
        ...mapState(useBrandingStore, ['preview']),
        ...mapState(useCommonStore, ['locale']),
        show () {
            return runningInBrowser() || this.hasContent;
        },
        hasContent () {
            return this.translatedPerks && !!this.translatedPerks.length;
        },
        perks1Width () {
            return responsive(this.preview.type, 'w-5/6 md:w-3/4 lg:w-5/6');
        },
        perksIconsWidth () {
            return responsive(this.preview.type, 'sm:px-16 w-3/4 md:w-1/2 lg:w-1/4');
        },
        perks2Width () {
            return responsive(this.preview.type, 'w-5/6 md:w-3/4 lg:w-3/4');
        },
        perks2IconsWidth () {
            return responsive(this.preview.type, 'w-11/12 md:w-11/12 lg:w-1/2');
        },
        perks2Margins () {
            return responsive(this.preview.type, 'pr-0 md:pr-0 lg:my-16')
        },
        titleSize() {
            return responsive(this.preview.type, 'text-body lg:text-heading-2');
        },
        textSize() {
            return responsive(this.preview.type, 'text-body-sm lg:text-body');
        },
        translatedPerks () {
            let perks = [];

            for (let perk of this.component.perks) {
                if (this.hasTrans(perk)) {
                    perks.push(perk);
                }
            }
            return perks;
        },
        title: {
            get () {
                return this.translated(this.component.title);
            }
        },
        description: {
            get () {
                return this.translated(this.component.description);
            }
        }
    },
    methods: {
        hasTrans (perk) {
            if (!this.translated(perk.title))
                return false;

            let title = this.translated(perk.title).trim();

            return title && title !== '';
        }
    },
    mounted () {

        if (runningInBrowser()) {
            containRetinaImages(this.$refs.container);
        }
    }
}
</script>

<style scoped>

</style>
